import React, { useEffect, useState } from "react";
import Loader from "../../../components/loader/loader";
import BreadCrumpBack from "../../../components/navigator/back";
import { user_bulk_emails } from "../user.api";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";
import "./messages.css";

export default function KSpaceMessages() {
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const servInstance = process.env.REACT_APP_BASE_URL || "";
  let result = servInstance ? servInstance.substring(0, servInstance?.length - 4) : "";

  useEffect(() => {
    fetchMessages();
  }, [page, perPage]);

  const fetchMessages = () => {
    setLoading(true);
    user_bulk_emails({ page, per_page: perPage })
      .then((res) => {
        if (res?.success && res?.data) {
          setMessages(res.data.data || []);
          setTotalPages(res.data.last_page || 1);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching messages:", err);
        setLoading(false);
      });
  };

  const handleShowMessage = (msg) => {
    setSelectedMessage(msg);
    setShowModal(true);
  };

  const handlePerPageChange = (e) => {
    setPerPage(parseInt(e.target.value));
    setPage(1);
  };

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      pages.push(
        <button key={1} className="btn btn-sm btn-outline-primary" onClick={() => setPage(1)}>1</button>
      );
      if (start > 2) pages.push(<span key="start-dots" className="px-1 text-primary">...</span>);
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-sm ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="end-dots" className="px-1 text-primary">...</span>);
      pages.push(
        <button key={totalPages} className="btn btn-sm btn-outline-primary" onClick={() => setPage(totalPages)}>{totalPages}</button>
      );
    }

    return pages;
  };

  return (
    <div className="messages-page">
      <Loader open={loading} />
      <div className="dash-banner">
        <div className="tit-txt">KSPACE Messages</div>
      </div>
      <div className="container mt-5 mb-5">
        <BreadCrumpBack />
        <div className="card shadow-sm mt-4">
          {/* <div className="card-header bg-white p-4">
            <h4 className="mb-0">Your Messages</h4>
            <p className="text-muted small mb-0">Official communications from KSPACE</p>
          </div> */}
          <div className="card-body p-0">
            {messages.length > 0 ? (
              <div className="list-group list-group-flush">
                {messages.map((msg) => (
                  <div
                    key={msg.id}
                    className="list-group-item list-group-item-action p-4 border-bottom"
                    onClick={() => handleShowMessage(msg)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="mb-1 text-primary">{msg.subject}</h5>
                      <span className="text-muted small">
                        {moment(msg.created_at).format("DD MMM YYYY")}
                      </span>
                    </div>
                    <p className="mb-1 text-truncate" style={{ maxWidth: '80%' }}>
                      {msg.body_text}
                    </p>
                  </div>
                ))}
              </div>
            ) : !loading ? (
              <div className="p-5 text-center">
                <i className="fa fa-envelope-open-o fa-3x text-muted mb-3"></i>
                <p>No messages found.</p>
              </div>
            ) : null}
          </div>

          {messages.length > 0 && (
            <div className="card-footer bg-white border-top p-4 d-flex justify-content-between align-items-center">
              <div className="flex-grow-1"></div>
              <div className="btn-group">
                <button
                  className="btn btn-sm btn-outline-primary"
                  disabled={page === 1}
                  onClick={() => setPage((p) => p - 1)}
                >
                  Prev
                </button>
                {renderPagination()}
                <button
                  className="btn btn-sm btn-outline-primary"
                  disabled={page === totalPages}
                  onClick={() => setPage((p) => p + 1)}
                >
                  Next
                </button>
              </div>
              <div className="flex-grow-1 d-flex justify-content-end">
                <select
                  className="form-control form-control-sm w-auto ml-2"
                  value={perPage}
                  onChange={handlePerPageChange}
                  style={{ fontSize: "8px", height: "31px" }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedMessage?.subject}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="mb-4 d-flex justify-content-between">
            <div>
              <small className="text-muted d-block">From</small>
              <strong>KSPACE Admin</strong>
            </div>
            <div className="text-end">
              <small className="text-muted d-block">Date</small>
              <strong>{moment(selectedMessage?.created_at).format("DD MMM YYYY, hh:mm A")}</strong>
            </div>
          </div>
          <hr />
          <div
            className="email-body mt-4"
            dangerouslySetInnerHTML={{ __html: selectedMessage?.body_html }}
          />
          {selectedMessage?.attachments && selectedMessage.attachments.length > 0 && (
            <div className="mt-5 border-top pt-4">
              <h6>Attachments:</h6>
              <div className="d-flex flex-wrap gap-2 mt-2">
                {selectedMessage.attachments.map((file, idx) => (
                  <a
                    key={idx}
                    href={result + 'storage/' + file.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-secondary"
                  >
                    <i className="fa fa-paperclip me-2"></i>
                    {file.name}
                  </a>
                ))}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
